import React from 'react';

import { createDashboardTableClassName } from './dashboardTableStyles';

export const DashboardTableWrapper: React.FC = ({ children }) => {
  const wrapperClassName = createDashboardTableClassName('wrapper');

  return <div className={wrapperClassName}>{children}</div>;
};
